import { CountryCodes } from '../../data/countryDialCodes';
const countryList = CountryCodes.map(c => ({ label: `${c.country} +${c.code}`, value: c.code }));

export function mapCountryDialCodeToCountryObject(code) {
  if (!code) return null;
  return countryList.find(c => c.value === code) || null;
}
